import { render, staticRenderFns } from "./EmbeddedVideoSection.vue?vue&type=template&id=3d1c4df5"
import script from "./EmbeddedVideoSection.vue?vue&type=script&lang=js"
export * from "./EmbeddedVideoSection.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedVideoSection.vue?vue&type=style&index=0&id=3d1c4df5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonRichText: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/RichText.vue').default})
